import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import img1 from "../../assets/Social/31 julyArtboard 4.png";
import img2 from "../../assets/Social/15-7-25Artboard 2.png";
import img3 from "../../assets/Social/24-7-25Artboard 1.png";
import img4 from "../../assets/Social/21-7-25Artboard 1 1.png";
import img5 from "../../assets/Social/3d-rendering-customizing-avatar-concept 1.png";

const NewPortfolioSocial = () => {
  const dataContext = useContext(AuthContext);
  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`w-full px-6 sm:px-10 md:px-20 transition-all duration-500 ${
        theme === "dark" ? "bg-white text-black" : "bg-black text-white"
      }`}
    >
      <section
        className={`relative mx-auto flex flex-col justify-center items-center py-5 md:py-20 transition-all duration-500 max-w-[1536px]`}
      >
        {/* Header Section */}
        <div className="flex flex-col justify-center items-center md:mb-10 text-center">
          <h1
            className={`bricolage-grotesque-bold font-bold mb-4 transition-all duration-500 ${
              theme === "dark" ? "text-black" : "text-white"
            } text-[26px] sm:text-[38px] md:text-[48px] lg:text-[54px]`}
          >
            Social Media Designs
          </h1>

          <h2
            className={`bricolage-grotesque-semibold font-semibold px-4 py-1 sm:py-2 rounded-full mb-2 transition-all duration-500 ${
              theme === "dark"
                ? "bg-[#d9d9d9] text-black"
                : "bg-[#232323] text-white"
            } text-[18px] sm:text-[24px] md:text-[28px] lg:text-[32px]`}
          >
            R.E.D. Trucking
          </h2>

          <h3
            className={`uppercase bricolage-grotesque-semibold font-bold transition-all duration-500 ${
              theme === "dark" ? "text-gray-800" : "text-white"
            } text-[14px] sm:text-[18px] md:text-[22px] lg:text-[24px]`}
          >
            A Logistic Company
          </h3>
        </div>

        {/* Grid Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 w-full">
          <img src={img1} alt="Social Design 1" className="w-full" />
          <img src={img2} alt="Social Design 2" className="w-full" />
          <img src={img3} alt="Social Design 3" className="w-full" />
          <img src={img4} alt="Social Design 4" className="w-full" />
        </div>

        {/* Featured Image Section */}
        <div className="flex justify-center w-full mt-3 md:mt-28">
          <img
            src={img5}
            alt="Featured Social"
            className={`w-full object-cover transition-all duration-500 ${
              theme === "dark"
                ? ""
                : "shadow-[0_-30px_60px_-10px_rgba(141,25,218,0.5),0_30px_60px_-10px_rgba(141,25,218,0.5),0_0_25px_-5px_rgba(141,25,218,0.4)] md:shadow-[0_-60px_120px_-20px_rgba(141,25,218,1),0_60px_120px_-20px_rgba(141,25,218,1),0_0_50px_-10px_rgba(141,25,218,0.6)]"
            }`}
          />
        </div>
      </section>
    </div>
  );
};

export default NewPortfolioSocial;
